/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, string, shape, bool, arrayOf, func,
} from 'prop-types';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';
import ReactHTMLParser from 'react-html-parser';
import { withStyles } from '@material-ui/core/styles';
import { Fade } from '@material-ui/core';
import { SideBySideMagnifier } from 'react-image-magnifiers';
import { bindActionCreators } from 'redux';
import Slider from 'react-slick';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Media from 'react-media';
import { actions as tagManagerActions } from '../../../../../../../state/ducks/TagManager';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import isProductListingAd from '../../../../../../helpers/isProductListingAd';
import { shouldRenderSnipe, snipePath, isSnipeImageActive } from '../../common/commonProductPageHelper';
import GraphqlClubPDPImage from '../../GraphqlClubPDPImage/GraphqlClubPDPImage';
import { clubComponentType } from '../../common/types';
import SnipeRender from '../../common/SnipeRender';
import SnipeRenderQuery from '../../common/SnipeRenderQuery';
import ResponsiveImage from '../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { getPmallSummaryInfo } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { pmallPluginConfig } from '../../../../../../../state/ducks/Common/ducks/PmallPersonalization/PmallPersonalization-Helper';
import InnerZoom from '../../../../GraphqlCommonComponents/InnerZoom';
import CarouselAltImg from '../CarouselAltImg';
import VideoComponent from '../VideoComponent';
import { getBrand } from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getActiveABTest } from '../../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import FavoritesUI from '../../../../GraphqlCommonComponents/Favourite/FavouriteUi';

const { sdkURL } = pmallPluginConfig;

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        background: theme?.palette?.white,
        [theme?.breakpoints?.down('md')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },
    sliderRoot: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        background: theme?.palette?.white,
    },
    altImageContainer: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme?.breakpoints?.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
            width: '100%',
        },
    },
    sliderAltImageContainer: {
        display: 'inline-block',
        flexWrap: 'wrap',
        margin: '20px 10px 10px 0px',
        maxWidth: '110px',
        '& $altImage': {
            width: '100%',
            height: '102px',
        },
        '& $videoAltButton': {
            '& img': {
                aspectRatio: '1/1.1',
            },
        },
        '& $whiteBg': {
            '& svg': {
                minHeight: '102px',
            },
        },
    },
    sliderPLARoot: {
        display: 'block',
    },
    sliderPlaAltImageContainer: {
        margin: '20px 10px 10px 0px',
        maxWidth: '100%',
        '& $sliderContainer': {
            '& .slick-slide': {
                padding: '0px 5px',
            },
            '& .slick-prev, & .slick-next': {
                transform: 'none',
                top: '32px',
            },
            '& .slick-next': {
                right: '-10px',
            },
            '& .slick-prev': {
                left: '-3px',
            },
        },
    },
    altImageButton: {
        display: 'block',
        padding: 0,
        margin: '0 10px 10px 0',
        position: 'relative',
        width: '100%',
        height: 'auto',
        border: 'none',
        outline: 'none', // TODO: Need to add outline for accessibility
        cursor: 'pointer',
        '& img': {
            display: 'block',
        },
        [theme?.breakpoints?.down('md')]: {
            maxWidth: '110px',
            width: '100%',
        },
    },
    whiteBg: {
        background: '#FFF',
    },
    altImage: {
        width: '100%',
        height: 'auto',
        opacity: '1 !important',
    },
    altImageMobile: {
        margin: '0 auto',
    },
    productImageWrapper: {
        flex: '1 1 auto',
        order: '2',
        maxWidth: '600px',
        width: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            order: '1',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        display: 'block',
        background: 'linear-gradient(270deg, #E7EDF1, #F2F8FC, #E7EDF1)',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
    },
    imageAspectRatioHeight: {
        paddingBottom: '109.5%',
        position: 'relative',
    },
    productVideo: {
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        minHeight: '597px',
        [theme.breakpoints.down(1350)]: {
            minHeight: 'auto',
        },
        objectFit: 'cover',
    },
    snipe: {
        position: 'absolute',
        top: '0px',
        right: '0',
        left: '0',
        width: '100%',
    },
    productImageWrapperClub: {
        display: 'inline-block',
        margin: '0',
        minWidth: '200px',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: '20px',
        },
        [theme?.breakpoints?.down('sm')]: {
            marginLeft: 0,
            maxWidth: '100%',
        },
    },
    monthSnipe: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        padding: 5,
        backgroundColor: 'rgba(47,47,47, .9)',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
    },
    upsellSelected: {
        '& span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    upsellImageBox: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        minWidth: '95px',
        minHeight: '114px',
        maxWidth: '110px',

        [theme.breakpoints.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            minHeight: 'auto',
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'inline-block',
            minHeight: 'auto',
            maxWidth: '100%',
        },
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
        '&:last-child': {
            margin: 0,
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        '& .slick-list': {
            display: 'none',
        },
        [theme.breakpoints.down('md')]: {
            width: '92%',
            margin: '0 auto',
        },
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            display: 'block',
            margin: '0 auto',
            '& .slick-slide': {
                float: 'left',
                whiteSpace: 'nowrap',
            },
            '& .slick-list': {
                display: 'block',
            },
        },
    },
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
    },
    videoAltButton: {
        '& img': {
            aspectRatio: '1/1.1',
        },
    },
    productImageWrapperInner: {
        position: 'relative',
    },
    simpleVideo: {
        width: '100%',
        top: 0,
        left: 0,
        right: 0,
        minHeight: '597px',
        objectFit: 'cover',
        position: 'absolute',
        [theme.breakpoints.down(1370)]: {
            minHeight: 'auto',
        },
    },
    videoMainImage: {
        minHeight: 'auto',
    },
    responsiveWrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        '& img[src*="addwine-snipe"]': {
            top: '-7px',
            right: '-7px',
            left: 'auto',
        },
    },
    sliderOuterContainer: {
        width: '100%',
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme.breakpoints.down('md')]: {
            order: '2',
            display: 'flex',
            maxWidth: '100%',
        },
    },
    sliderContainer: {
        position: 'relative',
        maxWidth: '1400px',
        margin: 'auto',
        '& .slick-list': {
            overflow: 'hidden',
            width: '90%',
            margin: '0 auto',
            [theme.breakpoints.up(1280)]: {
                height: '560px',
            },
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
        '& .slick-current': {
            paddingRight: 0,
        },
        '& .slick-prev, & .slick-next': {
            transform: 'rotate(90deg)',
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            width: 30,
            height: 25,
            position: 'absolute',
        },
        '& .slick-prev': {
            top: '-20px',
            left: '35%',
            opacity: '0.9',
            zIndex: '1',
        },
        '& .slick-next': {
            bottom: '-20px',
            right: '32%',
            opacity: '0.9',
        },
        '@media only screen and (max-width: 1280px) and (min-width: 600px)': {
            width: '100%',
        },
    },
    carouselContainer: {
        position: 'relative',
        width: '100%',
        '& .slick-list': {
            overflow: 'hidden',
            margin: '0px',
        },
        '& $altImageButton': {
            maxWidth: 'unset',
            width: '100px',
            padding: '0',
            backgroundColor: theme.palette.cms?.white || '#ffffff',
            margin: '0 0 5px',
        },
        '& $altImageContainer': {
            [theme?.breakpoints?.down('md')]: {
                margin: '0 10px 5px',
            },
        },
        '& $altImage': {
            width: '100%',
        },
        '& .slick-slide': {
            display: 'inline-block',
            width: 'auto !important',
        },
        '& .slick-prev, & .slick-next': {
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            top: '49%',
            width: 30,
            height: 100,
            position: 'absolute',
            background: 'rgb(245 245 245 / 81%)',
            zIndex: 9999,
            '& svg': {
                height: 'inherit',
            },
        },
        '& .slick-prev': {
            left: 0,
        },
        '& .slick-next': {
            right: 0,
        },
    },
    mainSliderContainer: {
        marginTop: '8px',
    },
    altImageName: {
        fontSize: '12px',
        margin: '-5px 0 10px 0',
        display: 'block',
    },
    pmallAltImageContainer: {
        textAlign: 'center',
    },
    upsellWrapper: {
        display: 'inline-block',
        flexWrap: 'wrap',
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    rootContainer: {
        '& $productImageWrapper': {
            maxWidth: '637px',
        },
    },
    plaAltImageButton: {
        maxWidth: '64px',
        '@media only screen and (max-width: 1280px)': {
            maxWidth: '100%',
            marginTop: '14px',
        },
        '& $carouselContainer': {
            '@media only screen and (max-width: 1026px) and (min-width: 800px)': {
                width: '80% !important',
            },
            '& $altImageButton': {
                maxWidth: '76px',
            },
            '& .slick-prev, & .slick-next': {
                top: '42%',
                height: '85px',
            },
        },

    },

});
class GraphqlProductImageUI extends Component {
    constructor(props) {
        super(props);
        const {
            data: {
                name,
                image,
            },
            selectedSku,
            pmallSummaryInfo,
            selectedSkuBasedAltImages,
        } = this.props;

        const imageName = selectedSku?.image?.name || '';
        const imagePath = selectedSku?.image?.path || '';

        let defaultImagePath = this.buildImgPath(imagePath, imageName);
        const productBaseAltImages = image?.additionalImages ? [...image.additionalImages] : [];
        const skuBasedAltImages = selectedSku?.image?.additionalImages ? [...selectedSku?.image.additionalImages] : [];
        const altImagesData = selectedSkuBasedAltImages ? [...productBaseAltImages, ...skuBasedAltImages] : productBaseAltImages;

        /**
         * This component is removed from the page on window resize which causes us to lose state.
         * When it returns, it should detect if there is a pmall preview avaialble. If
         * it is, initialize the component with it included in the altImages array
         * and set the default image to it.
         */

        if (pmallSummaryInfo?.customizations?.refnum) {
            defaultImagePath = this.buildImgPath(null, pmallSummaryInfo?.customizations?.imageURL);
            if (!altImagesData.includes(pmallSummaryInfo.customizations.imageURL)) {
                altImagesData.push(pmallSummaryInfo?.customizations?.imageURL);
            }
        }

        this.state = {
            path: imagePath,
            mainImage: {
                path: imageName,
                fullPath: defaultImagePath,
                imgName: name,
            },
            heroImage: defaultImagePath,
            altImages: altImagesData,
            modalOpen: false,
            selectedComponentMonth: 0,
            videoUrl: '',
            isVideo: false,
        };

        this.cdnLink = imagePath || 'https://cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/catalog/';
        this.defaultNoImage = 'https://images.contentstack.io/v3/assets/blt95e0138311135214/bltffae3c14fd3096e8/62e0138319ee366ebba54f3f/MissingImage.png'; // use for if image is missing
    }

    componentDidUpdate(prevProps) {
        const {
            selectedSku, pmallSummaryInfo, selectedSkuBasedAltImages, data,
        } = this.props;
        const { altImages } = this.state;

        /**
         * This block runs when the user finishes the pmall iFrame workflow.
         * We need to inject pmall data into the alt images that came from the product data.
         *
         * A problem in the edit pmall workflow is that the url never changes. Because of that
         * the hero image, if already selected, never gets updated. We need to run this
         * block every time pmall finishes. Since it runs every time, we dont want to pile up
         * previews. Be sure to only ever add 1.
         */
        if (prevProps.pmallSummaryInfo !== pmallSummaryInfo) {
            const newAltImages = [...altImages];

            if (!pmallSummaryInfo?.customizations?.imageURL) {
                const filterDefaultImgs = newAltImages.filter((altImg) => altImg && !altImg.includes(sdkURL));
                this.setState({
                    altImages: filterDefaultImgs,
                }, this.setProductImage(selectedSku.image?.name));
            } else {
                if (!newAltImages.includes(pmallSummaryInfo?.customizations?.imageURL)) {
                    newAltImages.push(pmallSummaryInfo?.customizations?.imageURL);
                }
                this.setState({
                    altImages: newAltImages,
                },
                // once pmall is part of the alt images, make it the hero as well
                this.setProductImage(pmallSummaryInfo?.customizations?.imageURL));

                return;
            }
        }

        if (prevProps.selectedSku !== selectedSku && selectedSku?.image) {
            const imageName = selectedSku.image?.name || '';
            const productBaseAltImages = data?.image?.additionalImages ? [...data?.image?.additionalImages] : [];
            const skuBasedAltImages = selectedSku?.image?.additionalImages ? [...selectedSku?.image.additionalImages] : [];
            const altImagesData = selectedSkuBasedAltImages ? [...productBaseAltImages, ...skuBasedAltImages] : productBaseAltImages;
            const pmallImage = pmallSummaryInfo?.customizations?.imageURL;
            this.setProductImage(imageName);
            if (selectedSkuBasedAltImages) {
                if (pmallImage && !altImagesData.includes(pmallImage)) {
                    altImagesData.push(pmallImage);
                }
                this.setState({ altImages: altImagesData });
            }
        }
    }

    buildImgPath = (path, name, isAlt) => {
        const { pmallSummaryInfo } = this.props;
        const alt = isAlt || false;
        if (!path || !name) {
            return this.defaultNoImage;
        }

        // eslint-disable-next-line no-nested-ternary
        const extension = name.includes('_gif') ? '.gif' : alt ? 'c.jpg' : 'x.jpg';
        if (name === pmallSummaryInfo?.customizations?.imageURL) {
            let url = `https:${pmallSummaryInfo?.customizations?.imageURL}`;
            /**
             * To prevent caching, add in a count parameter to the query. The imageURL
             * string recieved from the iFrame already contains a query.
             */
            url += `&cacheBust=${pmallSummaryInfo?.countCacheBust || 0}`;
            return url;
        }

        return `${path + name + extension}`;
    };

    // If selected SKU image is 404 render parent image
    onImageError = (e) => {
        const { data, presentationFamily } = this.props;
        if (data?.image?.path && presentationFamily === 'food') {
            const { image } = data;
            e.target.src = this.buildImgPath(image.path, image.name);
        }
        return null;
    }

    getSlides = (items, isSlider = false) => {
        const slides = [];
        const { classes, isClubPDPV2 } = this.props;
        const { selectedComponentMonth } = this.state;
        (items || []).forEach((imgName, index) => {
            slides.push(
                (
                    <div
                        key={`btnImg-${imgName.month}`}
                        className={`${isSlider ? classes.upsellWrapper : classes.upsellImageBox} ${(items[selectedComponentMonth]?.month === imgName.month) ? classes.upsellSelected : ''}`}
                    >
                        <button
                            data-testid={`component-${index}`}
                            onClick={() => {
                                if (!isClubPDPV2) {
                                    this.setState({ modalOpen: true, selectedComponentMonth: index });
                                }
                            }}
                            type="button"
                            className={classes.altImageButton}
                        >
                            <ResponsiveImage
                                path={`${this.cdnLink}${imgName.image?.name}t.jpg?width=110&height=124&auto=webp`}
                                alt={ReactHTMLParser(imgName.name)}
                                className={classes.altImage}
                                params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }}
                            />
                            {!isClubPDPV2 && <span className={classes.monthSnipe}>{imgName.month?.substr(0, 3)}</span>}
                        </button>
                    </div>
                ),
            );
        });
        return slides;
    }

    handleState = (obj) => {
        this.setState(obj);
    }

    /**
     * @description onClick handler for altImages to re-render hero image.
     * @note also used on componentDidUpdate.
     * @param {string} file
     * @param {string} contentType
     */
    setProductImage = (file, contentType = '') => {
        const { selectedSku, pmallSummaryInfo } = this.props;
        const { path } = this.state;
        let imageName = selectedSku?.image?.name || '';
        let imagePath = selectedSku?.image?.path || '';
        const defaultImagePath = imagePath && imageName ? this.buildImgPath(imagePath, imageName) : '';

        // intercept these variable and fine tune for pmall
        if (pmallSummaryInfo?.customizations?.imageURL) {
            imageName = pmallSummaryInfo?.customizations?.imageURL;
            imagePath = this.buildImgPath(null, imageName);
        }

        if (contentType) {
            this.setState({
                heroImage: this.buildImgPath(path, file),
                mainImage: {
                    path: imageName,
                    fullPath: defaultImagePath,
                    imgName: selectedSku.name,
                },
                isVideo: true,
                videoUrl: file,
            });
        } else {
            this.setState({
                heroImage: this.buildImgPath(path, file),
                mainImage: {
                    path: imageName,
                    fullPath: defaultImagePath,
                    imgName: selectedSku.name,
                },
                isVideo: false,
                videoUrl: '',
            });
        }
    };

    trackProductImageClick = () => {
        this.props.emitCustomTrackingEvent({
            eventType: 'custom',
            eventSubType: 'feature-tracking',
            action: 'Click',
            category: 'Product Image',
            label: 'Click on Image',
        });
    };

    renderZoom = () => {
        const { location, featureFlags } = this.props;
        const isPdpImageZoomEnabled = featureFlags['is-pdp-product-zoom-enabled'];
        const isPlaImageZoomEnabled = featureFlags['is-pla-product-zoom-enabled'];
        const isPla = isProductListingAd(location.search);
        if (isPla && isPlaImageZoomEnabled) return true;
        if (!isPla && isPdpImageZoomEnabled) return true;
        return false;
    }

    navigate = (type = 'next') => {
        const { selectedComponentMonth } = this.state;
        const { clubComponents } = this.props;
        const slidesLength = clubComponents?.length;
        if (type === 'next') {
            if ((slidesLength - 1) === selectedComponentMonth) {
                this.setState({ selectedComponentMonth: 0 });
            } else {
                this.setState({ selectedComponentMonth: (selectedComponentMonth + 1) });
            }
        } else if (type === 'prev') {
            if (selectedComponentMonth === 0) {
                this.setState({ selectedComponentMonth: (slidesLength - 1) });
            } else {
                this.setState({ selectedComponentMonth: (selectedComponentMonth - 1) });
            }
        }
    }

    getClubLengthDescription = () => {
        const { selectedSku } = this.props;
        const clubLength = selectedSku?.clubLength || 0;
        if (selectedSku?.date && selectedSku?.endDate) {
            return (
                <>
                    {`${clubLength} Months - ${selectedSku.date.month} ${selectedSku.date.year} - ${selectedSku.endDate.month} ${selectedSku.endDate.year}`}
                </>
            );
        }
        return null;
    }

    render() {
        const {
            featureFlags,
            classes,
            data,
            selectedSku,
            isClubProduct,
            clubComponents,
            renderSnipe,
            renderHeroImageFlag,
            altImagesContainerStyle,
            productBaseContent,
            setShippingModalOpen,
            presentationFamily,
            trackEvent,
            brand,
            productUrl,
            pdpImageZoomEnabled,
            partNumber,
            isClubPDPV2,
            plaAltImageHorizontal,
            isPlaPage,
            isPdpRedesignEnabled,
            isPlaRedesignEnabled,
        } = this.props;
        const {
            mainImage,
            altImages,
            path,
            heroImage,
            isVideo,
            videoUrl,
        } = this.state;
        const isBRY = brand?.code?.toLowerCase() === 'bry';
        const pdpImageStickyEnabled = featureFlags['pdp-image-sticky'];
        const videoBlock = productBaseContent?.entries?.[0]?.product_page_video || {};
        const previewImage = videoBlock?.static_image_preview?.url || '';
        const contentType = videoBlock?.video?.content_type || '';
        const isSliderEnabled = (presentationFamily === 'flower' && selectedSku?.image?.name && (
            (altImages.length >= 4 && !videoBlock?.enabled)
            || (altImages.length >= 3 && videoBlock?.enabled !== undefined)
        ));
        const videoImageStyles = (presentationFamily === 'flower' && !isSliderEnabled) ? classes.videoMainImage  : '';
        const videoClass = `${classes.simpleVideo} ${videoImageStyles}`;

        const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
        const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';
        const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
        const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;

        // Use heroImage state to update pdp images when skus are changed
        // To use only the main image and not update by sku, use presentation logic
        // to grab image source from data.image
        const personalizationFlag = featureFlags['is-personalization-enabled'] ?? false;

        // Added logic to render the snipe image on the main image only
        const altImagePath = heroImage?.split('/');
        const mainImagePath = mainImage?.fullPath?.split('/');

        // Check if the last segment of the alt image path matches the last segment of the main image path
        const showSnipeImage = altImagePath?.[altImagePath?.length - 1] === mainImagePath?.[mainImagePath?.length - 1];

        const nextArrow = () => (
            <div>
                <ChevronRightIcon onClick={() => trackEvent({
                    eventCategory: 'product carousel',
                    eventAction: 'next',
                    eventLabel: `${data.baseCode}`,
                    image_url: '',
                    image_alt: ReactHTMLParser(data?.name),
                    image_index: '',
                    image_count: '',
                })}
                />
            </div>
        );
        const backArrow = () => (
            <div>
                <ChevronLeftIcon onClick={() => trackEvent({
                    eventCategory: 'product carousel',
                    eventAction: 'previous',
                    eventLabel: `${data.baseCode}`,
                    image_url: '',
                    image_alt: ReactHTMLParser(data?.name),
                    image_index: '',
                    image_count: '',
                })}
                />
            </div>
        );
        const renderHeroImage = () => {
            const imageSource = heroImage || this.defaultNoImage;

            return (
                isVideo ? (
                    <VideoComponent
                        classes={classes}
                        videoUrl={videoUrl}
                        previewImage={previewImage}
                        videoClass={videoClass}
                        contentType={contentType}
                        videoBlock={videoBlock}
                        productBaseCode={data?.baseCode}
                        isBRY={isBRY}
                    />
                )
                    : (
                        <>
                            <div id="responsive-wrapper" className={classes.responsiveWrapper}>
                                {featureFlags['is-pdp-product-image-zoom-v2-enabled'] && pdpImageZoomEnabled === 'Variant' ? (
                                    <SideBySideMagnifier
                                        imageSrc={heroImage}
                                        imageAlt={ReactHTMLParser(data?.name)}
                                        largeImageSrc={heroImage}
                                        alwaysInPlace
                                    />
                                ) : (
                                    <InnerZoom
                                        magnifiedImageSrc={heroImage}
                                        enableZoom={featureFlags['is-pdp-product-image-zoom-enabled'] || false}
                                    >
                                        <>
                                            <ResponsiveImage
                                                className={classes.productImage}
                                                path={imageSource}
                                                alt={ReactHTMLParser(data?.name)}
                                                params={{
                                                    desktop: 'width=545&height=597',
                                                    tablet: 'width=406&height=445quality=100',
                                                }}
                                                breakpoints={{
                                                    desktop: '1024px',
                                                    tablet: '640px',
                                                }}
                                            />
                                            {renderSnipe && showSnipeImage && shouldRenderSnipe(data?.image?.snipe, personalizationFlag) && isSnipeImageActive(data?.image, 'pdp') && ( // if snipe data exist display snipe img
                                                <LazyLoad>
                                                    <Fade in timeout={700}>
                                                        <SnipeRender
                                                            altText={data?.image?.altText}
                                                            styleProp={classes.snipe}
                                                            src={`${data?.image?.snipeImagePath}${data?.image?.snipe}_z.gif?auto=webp`}
                                                            fallbackSrc={`${snipePath(data?.image.path)}${data?.image?.snipe}_z.gif?auto=webp`}
                                                        />
                                                    </Fade>
                                                </LazyLoad>
                                            )}
                                            {showSnipeImage && <SnipeRenderQuery  partNumber={partNumber || data?.partNumber || data?.id}  productType="product" />}
                                            <FavoritesUI partNumber={partNumber || data?.partNumber || data?.id} />
                                        </>
                                    </InnerZoom>
                                )}
                            </div>
                        </>
                    )
            );
        };

        const setLayout = () => (
            (renderHeroImageFlag)
                ? (
                    renderHeroImage()
                ) : (
                    <>
                        {this.renderZoom()
                            ? (
                                <>
                                    <SideBySideMagnifier
                                        className={classes.productImage}
                                        imageSrc={heroImage}
                                        imageAlt={ReactHTMLParser(data?.name)}
                                        largeImageSrc={heroImage}
                                    />
                                    {renderSnipe && showSnipeImage && shouldRenderSnipe(data?.image?.snipe, personalizationFlag) && isSnipeImageActive(data?.image, 'pdp') ? ( // if snipe data exsist display snipe img
                                        <LazyLoad>
                                            <Fade in timeout={700}>
                                                <SnipeRender
                                                    altText={data?.image?.altText}
                                                    styleProp={classes.snipe}
                                                    src={`${data?.image?.snipeImagePath}${data?.image?.snipe}_z.gif?auto=webp`}
                                                    fallbackSrc={`${snipePath(data.image.path)}${data?.image?.snipe}_z.gif?auto=webp`}
                                                />
                                            </Fade>
                                        </LazyLoad>
                                    ) : null}
                                </>
                            ) : (
                                renderHeroImage()
                            )}

                    </>
                )
        );

        if (!renderHeroImageFlag && isClubProduct) {
            const { modalOpen, selectedComponentMonth } = this.state;
            return (
                <div
                    data-testid="rendered-club-image"
                >
                    <GraphqlClubPDPImage
                        modalOpen={modalOpen}
                        handleState={this.handleState}
                        selectedComponentMonth={selectedComponentMonth}
                        cdnLink={this.cdnLink}
                        clubComponents={clubComponents}
                        product={data}
                        navigate={this.navigate}
                        getSlides={this.getSlides}
                        renderZoom={this.renderZoom}
                        shouldRenderSnipe={shouldRenderSnipe}
                        getClubLengthDescription={this.getClubLengthDescription}
                        selectedSku={selectedSku}
                        heroImage={heroImage}
                        personalizationFlag={personalizationFlag}
                        setShippingModalOpen={setShippingModalOpen}
                        productUrl={productUrl}
                        isClubPDPV2={isClubPDPV2}
                    />
                </div>
            );
        }

        const sliderClass = isSliderEnabled ? classes.sliderAltImageContainer : classes.altImageContainer;
        const altImageAddClass = plaAltImageHorizontal ? classes.sliderPlaAltImageContainer : sliderClass;
        const sliderRoot = isSliderEnabled ? classes.sliderRoot : classes.root;
        const sliderRootClass = plaAltImageHorizontal ? classes.sliderPLARoot : sliderRoot;
        const altDefaultImageRender = () => (
            <button
                type="button"
                className={classes.altImageButton}
                onClick={() => {
                    this.trackProductImageClick();
                    this.setProductImage(selectedSku?.image?.name);
                    trackEvent({
                        eventCategory: 'product image',
                        eventAction: 'click',
                        eventLabel: `${data?.baseCode} | ${this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name)} | 1`,

                        ga_event_name: 'image_carousel_interaction',
                        image_url: this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name),
                        image_alt: mainImage?.altImage,
                        image_index: 1,
                        image_count: altImages.length,
                    });
                }}
            >
                <ResponsiveImage
                    path={this.buildImgPath(selectedSku?.image?.path, selectedSku?.image?.name)}
                    alt={ReactHTMLParser(mainImage?.imgName)}
                    className={classes.altImage}
                    params={{
                        desktop: 'width=100&height=110', tablet: 'width=100&height=110', mobile: 'width=100&height=110',
                    }}
                />
            </button>
        );
        const videoBlockRender = () => (
            videoBlock?.enabled
                && (
                    <button
                        type="button"
                        className={`${classes.altImageButton}
                    ${classes.videoAltButton}`}
                        onClick={() => {
                            this.trackProductImageClick();
                            this.setProductImage(videoBlock?.video?.url, videoBlock?.video?.content_type);
                            trackEvent({
                                eventCategory: 'product image',
                                eventAction: 'click',
                                eventLabel: `${data?.baseCode} | ${previewImage} | 2`,
                            });
                        }}
                    >
                        <ResponsiveImage path={previewImage} alt="Video" className={classes.altImage} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                    </button>
                )
        );
        const ariaLabelledByID = (name, index) => `${ReactHTMLParser(name).toString().replace(/\s|\W/g, '_')}_alternate_image_${index || ''}`;// replace whitespace or non-word char with underscore
        const altImagesRender = () => (
            altImages.map((imgName, index) => (
                <button
                    key={`btnImg${imgName}`}
                    type="button"
                    aria-labelledby={ariaLabelledByID(ReactHTMLParser(mainImage?.imgName), index)}
                    className={classes.altImageButton}
                    onClick={() => {
                        this.trackProductImageClick();
                        this.setProductImage(imgName);

                        trackEvent({
                            eventCategory: 'product image',
                            eventAction: 'click',
                            eventLabel: `${data?.baseCode} | ${this.buildImgPath(path, imgName)} | ${videoBlock?.enabled ? index + 3 : index + 2}`, // default image + video thumb

                            ga_event_name: 'image_carousel_interaction',
                            image_url: this.buildImgPath(path, imgName, true),
                            image_alt: mainImage?.altImage,
                            image_index: index + 2,
                            image_count: altImages.length,
                        });
                    }}
                >
                    <ResponsiveImage
                        path={this.buildImgPath(path, imgName, true)}
                        alt={ReactHTMLParser(mainImage?.imgName)}
                        className={classes.altImage}
                        params={{ desktop: 'width=100&height=110', tablet: 'width=100&height=110', mobile: 'width=100&height=110' }}
                    />
                    <span hidden id={ariaLabelledByID(ReactHTMLParser(mainImage?.imgName), index)}>{`${ReactHTMLParser(mainImage?.imgName)} alternate image`}</span>
                </button>
            ))
        );

        // Render Video and Alt Images Based on Brand
        const videoAndAltImageRender = () => (
            isBRY ? (
                <>
                    {altImagesRender()}
                    {videoBlockRender()}
                </>
            ) : (
                <>
                    {videoBlockRender()}
                    {altImagesRender()}
                </>
            )
        );
        // Pmall Alt Images
        const pmallAltImageRender = () => (
            selectedSku?.image?.productThumbnails?.map((item, index) => (
                <div className={classes.pmallAltImageContainer}>
                    <button
                        key={`btnImg${item.name}`}
                        type="button"
                        className={classes.altImageButton}
                        onClick={() => {
                            this.trackProductImageClick();
                            this.setProductImage(item?.name);
                            trackEvent({
                                eventCategory: 'product image',
                                eventAction: 'click',
                                eventLabel: `${data?.baseCode} | ${this.buildImgPath(item?.path, item?.name)} | ${videoBlock?.enabled ? index + 3 : index + 2}`, // default image + video thumb
                            });
                        }}
                    >
                        <ResponsiveImage path={this.buildImgPath(item?.path, item?.name)} alt={ReactHTMLParser(item?.name)} className={classes.altImage} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                    </button>
                    <span className={classes.altImageName}>{item?.description}</span>
                </div>
            ))
        );

        // Render Pmall Alt Images Based on Brand
        const imageSticky = () => {
            if (data?.brandId === '1030' || data?.brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType) {
                return (
                    <>
                        {pmallAltImageRender()}
                        {altImagesRender()}
                    </>
                );
            }
            return (
                <>
                    {altDefaultImageRender()}
                    {videoAndAltImageRender()}
                </>
            );
        };

        return (
            <div className={`${sliderRootClass} ${isPdpRedesignEnabled ? classes.rootContainer : ''}`}>
                <div className={classes.productImageWrapper}>
                    <div className={classes.productImageWrapperInner}>
                        <div className={classes.imageAspectRatioHeight} />
                        {setLayout()}
                    </div>
                </div>
                {(altImages && !renderHeroImageFlag && !isPlaRedesignEnabled) && (
                    <div className={`${altImageAddClass} ${altImagesContainerStyle} ${isPlaRedesignEnabled ? classes.plaAltImageButton : ''}`}>
                        {isSliderEnabled ? (
                            <div className={classes.sliderOuterContainer}>
                                <Slider
                                    speed={500}
                                    slidesToShow={5}
                                    slidesToScroll={1}
                                    nextArrow={nextArrow()}
                                    prevArrow={backArrow()}
                                    lazyLoad="progressive"
                                    vertical={!plaAltImageHorizontal}
                                    verticalSwiping={!plaAltImageHorizontal}
                                    className={`carousel-container ${classes.sliderContainer}`}
                                    responsive={[
                                        {
                                            breakpoint: 1400,
                                            settings: {
                                                slidesToShow: 3,
                                                slidesToScroll: 1,
                                            },
                                        },
                                        {
                                            breakpoint: isPlaPage ? 1026 : 1100,
                                            settings: {
                                                slidesToShow: 2,
                                                slidesToScroll: 1,
                                            },
                                        },
                                        {
                                            breakpoint: 800,
                                            settings: {
                                                slidesToShow: 1,
                                                slidesToScroll: 1,
                                            },
                                        },
                                    ]}
                                >
                                    {(data?.brandId === '1030' || data?.brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType)
                                        ? [pmallAltImageRender(),
                                            videoBlockRender(),
                                            ...altImagesRender(),
                                        ] : [
                                            altDefaultImageRender(),
                                            videoBlockRender(),
                                            ...altImagesRender(),
                                        ]}
                                </Slider>
                            </div>
                        ) : (
                            <>
                                {pdpImageStickyEnabled
                                    ? (
                                        <Media
                                            query="(max-width: 1279px)"
                                        >
                                            {(matches) => (matches
                                                ? (
                                                    <CarouselAltImg
                                                        classes={classes}
                                                        buildImgPath={this.buildImgPath}
                                                        setProductImage={this.setProductImage}
                                                        selectedSku={selectedSku}
                                                        videoBlock={videoBlock}
                                                        data={data}
                                                        previewImage={previewImage}
                                                        mainImage={mainImage}
                                                        altImages={altImages}
                                                        path={path}
                                                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                                                    />
                                                )   : (
                                                    <div className={classes.sliderOuterContainer}>
                                                        {imageSticky()}
                                                    </div>
                                                ))}
                                        </Media>
                                    ) : (
                                        <div className={classes.sliderOuterContainer}>
                                            {imageSticky()}
                                        </div>
                                    )}
                            </>
                        )}

                    </div>
                )}
            </div>
        );
    }
}

GraphqlProductImageUI.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
    featureFlags: object,
    location: object.isRequired,
    presentationFamily: string.isRequired,
    selectedSku: object.isRequired,
    isClubProduct: bool,
    clubComponents: clubComponentType,
    renderSnipe: bool,
    renderHeroImageFlag: bool,
    altImagesContainerStyle: string,
    productBaseContent: shape({
        entries: arrayOf(shape({
            products_viewed_section: shape({
                background_color: string,
                copy: string,
                font_color: string,
            }),
        })),
    }),
    trackEvent: func.isRequired,
    emitCustomTrackingEvent: func.isRequired,
    pmallSummaryInfo: shape({
        customizations: shape({
            refnum: string,
            imageURL: string,
        }),
    }).isRequired,
    setShippingModalOpen: func,
    brand: shape({
        code: string.isRequired,
    }).isRequired,
    productUrl: string,
    pdpImageZoomEnabled: string.isRequired,
    partNumber: string,
    isClubPDPV2: bool,
    plaAltImageHorizontal: bool,
    isPlaPage: bool,
    isPdpRedesignEnabled: bool,
    isPlaRedesignEnabled: bool,
    selectedSkuBasedAltImages: bool,
};

GraphqlProductImageUI.defaultProps = {
    isClubProduct: false,
    clubComponents: [],
    renderSnipe: true,
    renderHeroImageFlag: false,
    altImagesContainerStyle: '',
    productBaseContent: {},
    setShippingModalOpen: () => { },
    featureFlags: {},
    productUrl: '',
    partNumber: '',
    isClubPDPV2: false,
    plaAltImageHorizontal: false,
    isPlaPage: false,
    isPdpRedesignEnabled: false,
    isPlaRedesignEnabled: false,
    selectedSkuBasedAltImages: false,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    emitCustomTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

const mapStateToProps = (state) => ({
    pmallSummaryInfo: getPmallSummaryInfo(state),
    brand: getBrand(state),
    pdpImageZoomEnabled: getActiveABTest('pdp_image_zoom_enabled_v2')(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GraphqlProductImageUI));
